export default "__VITE_ASSET__86c5f7ba__"